// 位置分类枚举
export const positionCategory = {
  home: 1,
  category: 2,
  featured: 3,
  community: 4,
  mine: 5,
};

// 默认的位置分类
export const defaultPositionCategory = positionCategory.home;

// 通常情况下位置分类顺序
export const positionCategoryOrder = [
  positionCategory.home,
  positionCategory.category,
  positionCategory.featured,
  positionCategory.community,
  positionCategory.mine,
];

// 位置分类枚举对应的文字
export const positionCategoryText = {
  [positionCategory.home]: '首页',
  [positionCategory.category]: '分类页',
  [positionCategory.featured]: '精选',
  [positionCategory.community]: '社区',
  [positionCategory.mine]: '我的',
};

// 指向类型枚举
export const pointingType = {
  productDetail: 1,
  productList: 2,
  independentH5: 3,
  functionalModule: 4,
};

// 默认的指向类型
export const defaultPointingType = pointingType.productDetail;

// 通常情况下指向类型顺序
export const pointingTypeOrder = [
  pointingType.productDetail,
  pointingType.productList,
  pointingType.independentH5,
  pointingType.functionalModule,
];

// 指向类型枚举对应文字
export const pointingTypeText = {
  [pointingType.productDetail]: '商品详情页',
  [pointingType.productList]: '商品列表页',
  [pointingType.independentH5]: '独立H5页面',
  [pointingType.functionalModule]: '功能模块页',
};

// 系统主题设置
export const settingTopic = {
  // App 基础配置
  appBase: 'app_base',
  // 签到奖励设置
  signAward: 'sign_award',
  // 淘宝联盟设置
  unionTaobao: 'union_taobao',
  // 京东联盟设置
  unionJd: 'union_jd',
  // 拼多多联盟设置
  unionPdd: 'union_pdd',
  // 提现设置
  withdraw: 'withdraw',
  // 会员设置
  member: 'member',
  // 支付设置
  payment: 'payment',
  // 第三方设置
  third: 'third',
};
